<template>
  <section>
    <qx-search-box
        class="searchBox"
        ref="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        title="筛选"
        permpisionsQuery=""
        :customSub="true"
    />
    <TableBox ref="tableBox" />
    <SubBtnBox :customPosifix="false"
               :cancelTextName="'返回'"
               :comfirmBtnHide="true"
    ></SubBtnBox>
  </section>
</template>

<script>
import TableBox from './tableBox';
import SubBtnBox from 'components/subBtnBox';
export default {
  components: {
    TableBox,
    SubBtnBox,
  },
  data () {
    return {
      searchBoxData: {
        form: [
          {
            label: '围栏名称',
            value: 'fenceName',
            type: 'input',
            placeholder: '请输入围栏名称',
            default: this.$route.query.fenceName ? decodeURIComponent(this.$route.query.fenceName) : '',
          },
          {
            label: '车牌号',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号',
          },
          {
            label: '进出时间',
            value: 'FenceTime',
            type: 'date',
            placeholder: '请选择进出时间',
            startPlaceholder: '进入时间',
            endPlaceholder: '离开时间',
            attr: {
              type: 'daterange',
            },
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.FenceTime && searchBoxData.FenceTime.length > 0) {
        searchBoxData.inFenceTime = this.formatDate(searchBoxData.FenceTime[0]);
        searchBoxData.outFenceTime = this.formatDate(searchBoxData.FenceTime[1]);
        delete searchBoxData.FenceTime;
      }
      delete searchBoxData.Date;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
